import React, { useMemo } from "react";

import { apiContenido } from "../../../../services/v2/lmsContenido.service";
import PanelContenido from "./panelContenido";
import PanelEvaluacion from "./panelEvaluacion";

/**
 * Las pestañas Contenido y Evaluación de la ficha de un curso o de un módulo (Catálogo › Cursos). Solo las ven quienes arman
 * contenido (Super Admin, Dirección Académica y Servicios Académicos); el servidor lo vuelve a verificar en cada petición.
 */
export const PanelDeNivel: React.FC<{ pestana: "contenido" | "evaluacion"; nivel: "curso" | "modulo"; id: number }> = ({ pestana, nivel, id }) => {
	const api = useMemo(() => apiContenido(nivel, id), [nivel, id])
	return pestana === "contenido" ? <PanelContenido api={api} /> : <PanelEvaluacion api={api} />
}

/** ¿Este usuario ve las pestañas Contenido y Evaluación? (sección Mis Clases sin ser maestro de aula.) */
export const veContenidoDelCurso = (acceso: any, currentUser: any): boolean => !!(acceso && acceso.read) && currentUser?.currentRole !== "mentor"

export default PanelDeNivel;
